import ChartMessage from 'components/ChartContainer/components/Chart/ChartMessage';
import React from 'react';
import { HttpError } from 'store/APIClient';
import DataLocked from 'assets/data_locked.svg?react';
import RequestError from 'assets/request_error.svg?react';
import { useTranslation } from 'react-i18next';
import PermissionErrorText from 'ui/PermissionErrorText/PermissionErrorText';

type Props = {
    isError: boolean;
    error: HttpError | null | unknown;
    children?: React.ReactNode;
};

export default function HttpErrorWrapper(props: Props): React.ReactElement {
    const { t } = useTranslation();
    const { isError, error, children } = props;

    if (isError) {
        if (error instanceof HttpError && [401, 403].includes(error.status)) {
            return (
                <ChartMessage>
                    <DataLocked />
                    <PermissionErrorText />
                </ChartMessage>
            );
        }
        return (
            <ChartMessage>
                <RequestError />
                <p>{t('common.requestError')}</p>
            </ChartMessage>
        );
    }
    return <>{children}</>;
}
